import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SidebarProvider } from './context/SidebarContext';
import { ModelProvider } from './context/ModelContext';
import { ProjectProvider } from './context/ProjectContext';
import { TeamsProvider } from './context/TeamsContext';
import ProtectedRoute from './components/ProtectedRoute';
import KeyboardShortcuts from './components/KeyboardShortcuts';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import ApplicationsPage from './pages/ApplicationsPage';
import AgentsPage from './pages/AgentsPage';
import { ENV } from './utils/env';
import './App.css';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Default redirection on success
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    // Set the active account after successful login
    const payload = event.payload as AuthenticationResult;
    if (payload && payload.account) {
      msalInstance.setActiveAccount(payload.account);
    }
  }
});

function App() {
  // Convert required role to array for ProtectedRoute component
  const requiredRoles = [ENV.REQUIRED_ROLE];

  return (
    <TeamsProvider>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <ThemeProvider>
            <SidebarProvider>
              <ModelProvider>
              <ProjectProvider>
              <Router>
              <div className="App">
                <Switch>
                  <Route path="/login" component={LoginPage} />
                  <Route>
                    <Switch>
                      <ProtectedRoute exact path="/" component={HomePage} roles={requiredRoles} />
                      <ProtectedRoute path="/applications" component={ApplicationsPage} roles={requiredRoles} />
                      <ProtectedRoute path="/agents" component={AgentsPage} roles={requiredRoles} />
                      <Route path="/unauthorized" component={UnauthorizedPage} />
                      {/* Add more protected routes here with specific roles if needed */}
                      <Route path="*">
                        <Redirect to="/" />
                      </Route>
                    </Switch>
                  </Route>
                </Switch>
                <KeyboardShortcuts />
              </div>
              </Router>
              </ProjectProvider>
              </ModelProvider>
            </SidebarProvider>
          </ThemeProvider>
        </AuthProvider>
      </MsalProvider>
    </TeamsProvider>
  );
}

export default App;